export default "__VITE_ASSET__BdAoHTFV__"